const axios = require('axios').default;
const API_URL = process.env.NOTIFICATIONS_API_URL;
const API_KEY = process.env.NOTIFICATIONS_API_KEY;

/*** IMPORTED FROM CSR ***/

/**
 * @param {*} recipientId 
 * @param {*} message
 * @param {*} messageId
 */
const replyMessage = async (recipientId, message, messageId, attachments) => {
    const username = "CSR"
    const body = {
        recipientId: recipientId,
        message: message,
        messageId: messageId,
        username: username,
        attachments
    };
    const response = await axios.post(`${API_URL}replyToPortalMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const replyMessageWithAttachment = async (recipientId, formData) => {
    formData.append("recipientId", recipientId);
    formData.append("username", 'CSR');
    const response = await axios.post(`${API_URL}replyToPortalMessageWithAttachment`, formData.getBuffer(), {
        headers: {
            ...formData.getHeaders(),
            Authorization: API_KEY,
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        },
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} messageId
 * @param {*} completed
 * @param {*} replyRequired
 */
const updateMessage = async (messageId, completed, replyRequired) => {
    const body = {
        messageId: messageId,
        completed: completed,
        replyRequired: replyRequired
    };
    const response = await axios.post(`${API_URL}updateMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} recipientId
 * @param {*} message
 * @param {*} subject
 */
const createInAppMessage = async (recipientId, message, subject, attachments) => {
    const body = {
        recipientId: recipientId,
        message: message,
        subject: subject,
        attachments
    };
    const response = await axios.post(`${API_URL}createInAppMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const createInAppMessageWithAttachment = async (recipientId, formData) => {
    formData.append("recipientId", recipientId);
    const response = await axios.post(`${API_URL}createInAppMessageWithAttachment`, formData.getBuffer(), {
        headers: {
            ...formData.getHeaders(),
            Authorization: API_KEY,
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        },
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
};

/**
 * @param {*} completed true or false
 */
const getPortalMessagesApiCall = async (recipientId, completed) => {
    const notificationType = 'CSR';
    let params = recipientId ? { notificationType: notificationType, completed: completed, recipientId: recipientId } : { notificationType: notificationType, completed: completed };
    const response = await axios.get(`${API_URL}getCSRMessages`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

/**
 * this name might just be first or last or both
 * returns list of (data = array of npi / doctor data)
 */
const getCSRReplyMessages = async () => {
    const response = await axios.get(`${API_URL}getCSRReplies`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

/*** IMPORTED FROM MEMBER ***/

/**
 * @param {*} recipientId 
 * @param {*} message
 * @param {*} topic
 */
const createPortalMessageApiCall = async (recipientId, message, topic, attachments) => {
    const body = {
        recipientId: recipientId,
        message: message,
        topic: topic,
        attachments
    };
    const response = await axios.post(`${API_URL}submitPortalMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const createPortalMessageWithAttachmentApiCall = async (recipientId, formData) => {
    formData.append("recipientId", recipientId);
    const response = await axios.post(`${API_URL}submitPortalMessageWithAttachment`, formData.getBuffer(), {
        headers: {
            ...formData.getHeaders(),
            Authorization: API_KEY,
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        },
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} recipientId 
 * @param {*} message
 * @param {*} topic
 */
const createPortalHelpMessageApiCall = async (message) => {
    const body = {
        email: message.memberEmail,
        phone: message.memberPhone,
        bestTime: message.bestTime,
        message: message.messageText,
        topic: message.topic,
        createTimestamp: message.createTimestamp,
        name: message.memberName
    };
    const response = await axios.post(`${API_URL}submitHelpMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} recipientId 
 * @param {*} messageId
 */
const setReadMessageApiCall = async (recipientId, messageId) => {
    const body = {
        recipientId: recipientId,
        messageId: messageId
    };
    const response = await axios.post(`${API_URL}setReadMessage`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} recipientId 
 * this name might just be first or last or both
 * returns list of (data = array of npi / doctor data)
 */
const getUserNotificationsApiCall = async (recipientId) => {
    const recipientType = 'legacy_member';
    const notificationType = 'InApp';
    const response = await axios.get(`${API_URL}getRecipientNotifications?recipientId=${recipientId}&recipientType=${recipientType}&notificationType=${notificationType}`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

/**
 * @param {*} recipientId 
 * version 2 call of the get member notifications
 */
const getMemberNotifications = async (recipientId) => {
    const recipientType = 'member-record';
    const notificationType = 'InApp';
    const response = await axios.get(`${API_URL}getRecipientNotifications?recipientId=${recipientId}&recipientType=${recipientType}&notificationType=${notificationType}`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

/**
 * @param {*} recipientId 
 * @param {*} device
 */
const configureDeviceApiCall = async (recipientId, device) => {
    const body = {
        recipientId: recipientId,
        deviceToken: device.deviceToken,
        deviceType: device.deviceType
    };
    const response = await axios.post(`${API_URL}registerMobileDevice`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} destinationAddresses
 * @param {*} subject
 * @param {*} messageText
 */
const sendServiceEmail = async (destinationAddresses, subject, messageText) => {
    const body = {
        destinationAddresses: destinationAddresses,
        subject: subject,
        messageText: messageText
    };
    const response = await axios.post(`${API_URL}sendServiceEmail`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @param {*} recipientId 
 * @param {*} recipientType
 * 
 * returns list of (data = array of devices)
 */
const getRecipientDevices = async (recipientId, recipientType) => {
    const response = await axios.get(`${API_URL}getDevices?recipientIdentifier=${recipientId}&recipientType=${recipientType}`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const getPreSignedUrl = async (data) => {
    const response = await axios.get(`${API_URL}getPreSignedUrl?${encodeData(data)}`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const encodeData = (data) => {
    return Object.keys(data).map((key) => {
        return [key, data[key]].map(encodeURIComponent).join("=");
    }).join("&");
}

const get = async (path, params) => {
    const response = await axios.get(`${API_URL}${path}`, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        },
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const put = async (body, path) => {
    const response = await axios.put(`${API_URL}${path}`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const post = async (body, path) => {
    const response = await axios.post(`${API_URL}${path}`, body, {
        headers: {
            Authorization: API_KEY,
            'content-type': 'application/json'
        }
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const getPendingEmails = async (skipAutoRedirect = false) => {
    let redirectUrl = '';
    try {
        const response = await axios.get(`${API_URL}getPendingEmails`, {
            headers: {
                Authorization: API_KEY,
                'content-type': 'application/json'
            },
            beforeRedirect: (options, { headers }) => {
                if (options && options.href) {
                    redirectUrl = options.href;
                    throw new Error('redirect');
                }
            }
        });
        if (response.status !== 200) {
            return null;
        }
        return response.data;
    } catch (e) {
        if (redirectUrl) {
            if (skipAutoRedirect) {
                return {
                    redirectUrl: redirectUrl
                };
            } else {
                const response = await axios.get(redirectUrl);
                if (response.status !== 200) {
                    return null;
                }
                return response.data;
            }
        } else {
            throw e;
        }
    }
}

module.exports = {
    createInAppMessage,
    createInAppMessageWithAttachment,
    updateMessage,
    createPortalMessageApiCall,
    createPortalMessageWithAttachmentApiCall,
    createPortalHelpMessageApiCall,
    configureDeviceApiCall,
    getMemberNotifications,
    getUserNotificationsApiCall,
    getPortalMessagesApiCall,
    getCSRReplyMessages,
    setReadMessageApiCall,
    sendServiceEmail,
    replyMessage,
    replyMessageWithAttachment,
    getRecipientDevices,
    getPreSignedUrl,
    get,
    put,
    post,
    getPendingEmails,
}